export const EquiposInfraestructuraImg = [
  {
    title: "Equipos de Infraestructura",
    path: "../../../soluciones/videoconferencia/equipos-infra/img1.jpg",
    cName: "carousel-img-videoconferencia img-videoconferencia-1",
  },
  {
    title: "Equipos de Infraestructura",
    path: "../../../soluciones/videoconferencia/equipos-infra/img2.jpg",
    cName: "carousel-img-videoconferencia img-videoconferencia-2",
  },
  {
    title: "Equipos de Infraestructura",
    path: "../../../soluciones/videoconferencia/equipos-infra/img3.jpg",
    cName: "carousel-img-videoconferencia img-videoconferencia-3",
  },
  {
    title: "Equipos de Infraestructura",
    path: "../../../soluciones/videoconferencia/equipos-infra/img4.jpg",
    cName: "carousel-img-videoconferencia img-videoconferencia-4",
  },
]
